import { ValidateJSModel, ValidateJSModelAttribute } from 'forms/shared/types';
import locationModelValidator from '../location';
import { LocationModel } from '../types';

interface LocationBirthplaceWithoutCountyModel {
  city: LocationModel['city']
  state: LocationModel['state']
  country: LocationModel['country']
}

const locationBirthplaceWithoutCountyModelValidator: ValidateJSModel<LocationBirthplaceWithoutCountyModel> = {
  city: locationModelValidator.city as ValidateJSModelAttribute<
    LocationBirthplaceWithoutCountyModel,
    'city'
  >,
  state: locationModelValidator.state as ValidateJSModelAttribute<
    LocationBirthplaceWithoutCountyModel,
    'state'
  >,
  country: locationModelValidator.country as ValidateJSModelAttribute<
    LocationBirthplaceWithoutCountyModel,
    'country'
  >,
};

export default locationBirthplaceWithoutCountyModelValidator;
